"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// Source: /frontend/js/src/preact-components/assets/icon-forbidden.tsx
var Forbidden = function Forbidden(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "currentColor",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("path", {
    d: "M10.5007 0.083252C11.8686 0.083252 13.2231 0.352687 14.4869 0.876173C15.7507 1.39966 16.8991 2.16695 17.8663 3.13422C18.8336 4.1015 19.6009 5.24982 20.1244 6.51363C20.6479 7.77744 20.9173 9.13198 20.9173 10.4999C20.9173 13.2626 19.8198 15.9121 17.8663 17.8656C15.9128 19.8191 13.2633 20.9166 10.5007 20.9166C9.13271 20.9166 7.77817 20.6472 6.51436 20.1237C5.25056 19.6002 4.10223 18.8329 3.13496 17.8656C1.18145 15.9121 0.0839844 13.2626 0.0839844 10.4999C0.0839844 7.73725 1.18145 5.08773 3.13496 3.13422C5.08846 1.18072 7.73798 0.083252 10.5007 0.083252ZM10.5007 2.16659C8.29051 2.16659 6.1709 3.04456 4.60809 4.60736C3.04529 6.17017 2.16732 8.28978 2.16732 10.4999C2.16732 12.427 2.82357 14.1978 3.91732 15.6145L15.6152 3.91658C14.152 2.78149 12.3525 2.16579 10.5007 2.16659ZM10.5007 18.8333C12.7108 18.8333 14.8304 17.9553 16.3932 16.3925C17.956 14.8297 18.834 12.7101 18.834 10.4999C18.834 8.57283 18.1777 6.802 17.084 5.38534L5.38607 17.0833C6.8493 18.2183 8.64876 18.834 10.5007 18.8333Z"
  }));
};

var _default = Forbidden;
exports.default = _default;